<template src="./forgot.html"></template>

<script>
import axios from 'axios'
  export default {
    data () {
      return {
        email: null
      }
    },
    methods: {
      reset () {
        if (!this.email) {
          this.swal({ type: 'error', title: 'Email required', text: 'Please enter your email address.' })
          return
        }
        axios.post('/api/auth/forgot-password', { email: this.email }).then(response => {
          this.swal({
            type: 'success',
            title: 'Password reset',
            text: (response.data && response.data.message) || ('If an account exists for ' + this.email + ', a reset link was sent.')
          })
          this.$router.push('/login')
        }).catch(err => {
          const msg = (err.response && err.response.data && err.response.data.error) || err.message || 'Request failed'
          this.swal({ type: 'error', title: 'Could not send reset email', text: msg })
        })
      }
    }
  }
</script>

<style>

</style>
